import React from 'react';
import s from './Btn.module.css';
export function Btn({children,variant='primary',size='md',icon,disabled,onClick,type='button',style}){
  return(
    <button type={type} className={`${s.b} ${s[variant]} ${s[size]}`} disabled={disabled} onClick={onClick} style={style}>
      {icon&&<span className={s.ic}>{icon}</span>}{children}
    </button>
  );
}
